import { semanticVersionGTE } from "@clockwise/client-commons/src/util/semantic-version.util";

const ChromeExtensionLabeledVersions = {
  // Before BulkExperiments, the local storage experiment cache the crx used would get stale, which
  // broke the scheduler buttons and inline suggestion carousel. This version fixed it.
  BulkExperiments: "1.6.0",
};

export const haveIntroduced = (
  labeledVersion: keyof typeof ChromeExtensionLabeledVersions,
  currentVersion: string,
): boolean => {
  return semanticVersionGTE(currentVersion, ChromeExtensionLabeledVersions[labeledVersion]);
};
